import React, { useEffect, useState } from "react";
import "./styles.scss";
import "leaflet/dist/leaflet.css";
import { MapContainer, TileLayer, Marker, Popup, GeoJSON } from "react-leaflet";
import { Icon } from "leaflet";
import { FlexBox } from "../styles/global";
import chroma from "chroma-js";
import {
  BorderDivisor,
  CardInfo,
  Circle,
  DivCloseButton,
  FlexBottom,
  LegendMap,
  ModalStyles,
  PLineHeigth,
  PLineHeigth2,
  SelectMapGeojson,
  Teste,
  TitleCardNew,
} from "./styled";
import TesteFetcher from "../components/Card/Card";

import imagemTeste from "../assets/arrow-right.png";

import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import GetHospitalData from "../components/GetHospitalData/GetHospitalData";
import { useDataContext } from "../context/DataContext";
import { Full } from "../components/DataFetcher/styled-datafetcher";
import ReactLoading from "react-loading";
import EspecialidadesList from "../components/EspecialidadesCard/Especialidades";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// create custom icon
const customIcon = new Icon({
  iconUrl: require("../assets/pin.png"),
  iconSize: [38, 38], // size of the icon
});

// markers
const markers = [
  {
    geocode: [-15.822499, -48.069254],
    popUp: "HRT",
  },
  {
    geocode: [-15.83733, -48.060573],
    popUp: "HSVP",
  },
  {
    geocode: [-15.648064, -47.792811],
    popUp: "HRS",
  },
  {
    geocode: [-15.818028, -47.986391],
    popUp: "HRGu",
  },
  {
    geocode: [-15.853309, -48.073219],
    popUp: "HRSam",
  },
  {
    geocode: [-15.67493, -48.203732],
    popUp: "HRBz",
  },
  {
    geocode: [-15.781722, -47.781664],
    popUp: "HRL",
  },
  {
    geocode: [-15.625454, -47.652764],
    popUp: "HRPL",
  },
  {
    geocode: [-16.0236, -48.06868],
    popUp: "HRG",
  },
  {
    geocode: [-15.78432, -47.882287],
    popUp: "HRAN",
  },
  {
    geocode: [-15.8154, -48.096266],
    popUp: "HRC",
  },
  {
    geocode: [-15.823527, -47.896826],
    popUp: "HMIB",
  },
];

function openPopup(e) {
  e.target.openPopup();
}

export default function Maps() {
  const {
    loading,
    metricasEspecialidades,
    macrorregiaoColorMap,
    especialidadesColorMap,
  } = useDataContext();
  const [name, setNameHospital] = useState();
  const [open, setOpen] = useState(false);
  const [colorMap, setColorMap] = useState({});
  const [geoJsonData, setGeoJsonData] = useState(null);
  const [geoJsonDataRA, setGeoJsonDataRA] = useState(null);

  const [value, setValue] = React.useState("");

  const handleChange = (event) => {
    setValue(event.target.value);

    if (event.target.value === "admin") {
      generateColors(geoJsonData);
    } else {
      generateColorsRA(geoJsonDataRA);
    }
  };

  // Função para gerar um conjunto de cores baseadas no valor de 'ra_codigo'
  const generateColors = (data) => {
    const raCodigos = [
      ...new Set(data.features.map((feature) => feature.properties.ra_codigo)),
    ];
    const colorScale = chroma.scale("Set1").colors(raCodigos.length); // Gera cores diferentes para cada 'ra_codigo'

    const colorMapping = raCodigos.reduce((acc, ra_codigo, index) => {
      acc[ra_codigo] = colorScale[index];
      return acc;
    }, {});

    setColorMap(colorMapping);
  };

  const generateColorsRA = (data) => {
    const raCodigos = [
      ...new Set(data.features.map((feature) => feature.properties.nome)),
    ];

    const colorScale = chroma.scale("Set1").colors(raCodigos.length); // Gera cores diferentes para cada 'ra_codigo'

    const colorMapping = raCodigos.reduce((acc, ra_codigo, index) => {
      acc[ra_codigo] = colorScale[index];

      return acc;
    }, {});

    setColorMap(colorMapping);
  };

  const regionStyle = (feature) => {
    // generateColors(geoJsonData);

    const fillColor = colorMap[feature.properties.ra_codigo] || "blue"; // Usa a cor mapeada ou uma cor padrão
    return {
      fillColor: fillColor,
      color: "grey", // Cor da borda
      weight: 2,
      fillOpacity: 0.2,
    };
  };

  const regionStyleRA = (feature) => {
    // generateColorsRA(geoJsonDataRA);

    const fillColor = colorMap[feature.properties.nome] || "blue"; // Usa a cor mapeada ou uma cor padrão
    return {
      fillColor: fillColor,
      color: "grey", // Cor da borda
      weight: 2,
      fillOpacity: 0.2,
    };
  };

  useEffect(() => {
    geoJsonDataRA && generateColorsRA(geoJsonDataRA);
  }, [geoJsonDataRA]);

  // Carrega o arquivo .geojson ao montar o componente
  useEffect(() => {
    fetch("regioes_adm.geojson")
      .then((response) => response.json())
      .then((data) => {
        setGeoJsonData(data);
      })
      .catch((error) => {
        console.error("Erro ao carregar o arquivo .geojson:", error);
      });
    fetch("regiao_saude.geojson")
      .then((response) => response.json())
      .then((data) => {
        setGeoJsonDataRA(data);

        setValue("saude");
      })
      .catch((error) => {
        console.error("Erro ao carregar o arquivo .geojson:", error);
      });
  }, []);

  function handleViewe(name) {
    setNameHospital(name);
    setOpen(true);
  }

  if (loading)
    return (
      <Full>
        <ReactLoading
          type={"spinningBubbles"}
          color="#fff"
          height={200}
          width={200}
        />
      </Full>
    );

  return (
    <div className="teste">
      <MapContainer
        // scrollWheelZoom={false}
        center={[-15.781722, -47.781664]}
        zoom={11}
        minZoom={11}
        maxZoom={15}
        // zoomControl={false}
        style={{ width: "100%", borderRadius: 0 }}
      >
        {value === "admin" && (
          <GeoJSON data={geoJsonData} style={regionStyle} />
        )}
        {value === "saude" && (
          <GeoJSON data={geoJsonDataRA} style={regionStyleRA} />
        )}
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        {markers?.map((marker, index) => (
          <Marker
            key={index}
            position={marker.geocode}
            icon={customIcon}
            eventHandlers={{
              add: openPopup,
            }}
          >
            <Popup
              closeButton={false}
              autoClose={false}
              closeOnClick={false}
              className={marker?.popUp}
            >
              <Teste
                margin="10px"
                align="center"
                direction="column"
                width="auto"
                onClick={() => handleViewe(marker?.popUp)}
                color={macrorregiaoColorMap[marker.popUp]}
              >
                <FlexBox>
                  <FlexBox direction="column" justify="center">
                    <TitleCardNew color={macrorregiaoColorMap[marker.popUp]}>
                      <h2>{marker?.popUp}</h2>
                    </TitleCardNew>

                    <CardInfo
                      color={GetHospitalData(marker.popUp)?.CordeValidação}
                      textAling="center"
                    >
                      <FlexBox
                        direction="column"
                        align="center"
                        justify="center"
                        textAling="center"
                      >
                        <FlexBox
                          direction="column"
                          align="center"
                          justify="center"
                          textAling="center"
                        >
                          <PLineHeigth>Pacientes aguardando</PLineHeigth>

                          <span>
                            {GetHospitalData(marker.popUp)?.PacientesAguardando}
                          </span>
                          <PLineHeigth2>agora</PLineHeigth2>
                        </FlexBox>
                      </FlexBox>
                      {GetHospitalData(marker.popUp)?.GAESAbertas && (
                        <>
                          <BorderDivisor />

                          <FlexBox
                            direction="column"
                            align="center"
                            justify="center"
                            textAling="center"
                          >
                            <PLineHeigth>GAES Abertas</PLineHeigth>
                            <span>
                              {GetHospitalData(marker.popUp)?.GAESAbertas}
                            </span>
                            <PLineHeigth2>últimas 24h</PLineHeigth2>
                          </FlexBox>
                        </>
                      )}
                    </CardInfo>
                  </FlexBox>

                  <FlexBox width="58%">
                    <EspecialidadesList
                      key={marker.id}
                      titulo={marker.popUp}
                      metricasEspecialidades={metricasEspecialidades}
                    />
                  </FlexBox>
                </FlexBox>

                <img className="position-img" src={imagemTeste} alt="teste" />
              </Teste>
            </Popup>
          </Marker>
        ))}
      </MapContainer>

      <LegendMap>
        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography>Legenda</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <table>
              <thead>
                <tr>
                  <th>Especialidade</th>
                  <th> Cor</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(especialidadesColorMap).map(
                  ([especialidade, cor]) => (
                    <tr key={especialidade}>
                      <td>{especialidade}</td>
                      <td>
                        <FlexBox justify="center">
                          <Circle color={cor}> </Circle>
                        </FlexBox>
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
          </AccordionDetails>
        </Accordion>
      </LegendMap>

      <SelectMapGeojson>
        <FormControl>
          <FormLabel id="demo-controlled-radio-buttons-group">
            Visualização do mapa
          </FormLabel>
          <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            value={value}
            onChange={handleChange}
          >
            <FormControlLabel
              value="admin"
              control={<Radio />}
              label="Região Admin"
            />
            <FormControlLabel
              value="saude"
              control={<Radio />}
              label="Região Saúde "
            />
          </RadioGroup>
        </FormControl>
      </SelectMapGeojson>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <ModalStyles>
          <FlexBottom
            align="center"
            justify="center"
            direction="column"
            position="relative"
            width="max-content"
          >
            <DivCloseButton>
              <Button onClick={() => setOpen(false)}>X</Button>
            </DivCloseButton>

            <TesteFetcher name={name} />
          </FlexBottom>
        </ModalStyles>
      </Modal>
    </div>
  );
}
